import React from "react";
import * as actions from '../Actions';

export default function ReplyOverlay({ eleRef }) {
    return (
        <div className="comment-overlay" onClick={(e) => actions.closeCommentPopup(e)}>
            <div className="comment-popup">
                <div className="comment-header">
                    <span className="B14_42">ADD NEW REPLY TO THIS COMMENT</span>
                    <span className="closeButton icon" data-icon-font="C" onClick={(e) => actions.closeCommentPopup(e)}></span>
                </div>
                <div className="comment-container participate-container">
                    <div className="write-comment-container">
                        <div className="participate-box">
                            <div className="comment-title">
                                <span id="ParentCommentContent" className="R14_61"></span>
                            </div>
                        </div>
                        <div className="comment-reply-box">
                            <textarea id="postComment" className="R12_9e" placeholder="Write your reply here"></textarea>
                            <label htmlFor="fileupload">
                                <div className="participate-attachment">
                                    <div data-icon-font="o" className="icon R16_42"></div>
                                    <span className="R14_61">Attachments</span>
                                </div>
                            </label>
                        </div>
                        <div className="post_comment addComment" onClick={(e) => actions.addComment(1, eleRef)}>
                            <button type="submit" className="askB_1" id="dev_replypost">
                                <span className="B14_white" id="dev_replypost">POST</span>
                                <span className="icon" data-icon-font="&#xe00d;" id="dev_replypost"></span>
                            </button>
                        </div>
                        <div className="comment-box-send">
                            <div className="isAnonymousBlock">
                                <span className="icon isAnonymous" data-icon-font="z" onClick={() => actions.checkCheckbox(1)}></span>
                                <span className="post_anonymus">Post Anonymously</span>
                            </div>
                        </div>
                        <div className="file_upload_err"></div>
                        <div className="uploaded-files-list">
                            <ul>
                                <li className="cmt-image">
                                    <span data-icon-font="`" className="icon"></span>
                                    <span className="added-file-name"></span>
                                    <span data-icon-font="&#xe013;" className="icon right" onClick={() => actions.cmtFileDelete('image')}></span>
                                </li>
                                <li className="cmt-pdf">
                                    <span data-icon-font="&#xe039;" className="icon"></span>
                                    <span className="added-file-name"></span>
                                    <span data-icon-font="&#xe013;" className="icon right" onClick={() => actions.cmtFileDelete('pdf')}></span>
                                </li>
                            </ul>
                        </div>
                        <input type="file" id="fileupload" onChange={() => actions.cmtFileUpload()} style={{ display: 'none' }} />
                    </div>
                </div>
            </div>
        </div>
    );
}
